import Image from "next/image";

const MainLoader = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <div
      className="fixed top-0 right-0 z-[999] flex h-full w-full items-center justify-center bg-[#d0d0d059]"
      style={{
        display: isLoading ? "flex" : "none",
      }}
    >
      <div>
        <Image alt="loader" src="/assets/loader.gif" height={260} width={260} />
      </div>
    </div>
  );
};

export default MainLoader;
